export default __webpack_public_path__ + "static/media/female-face.1ebdca81.png";